import { render, staticRenderFns } from "./teacherList.vue?vue&type=template&id=316afe76&scoped=true&"
import script from "./teacherList.vue?vue&type=script&lang=js&"
export * from "./teacherList.vue?vue&type=script&lang=js&"
import style0 from "./teacherList.vue?vue&type=style&index=0&id=316afe76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316afe76",
  null
  
)

export default component.exports